import { getCol as getColBase } from "../../../../common/getCol.ts";
import type { Col } from "../components/DataTable/index.tsx";
import i18n from "./i18n.ts";

export const getCol = (title: string, overrides?: Partial<Col>): Col => {
	const col = getColBase(title, overrides);
	const key = title.replace(/:/g, "_");
	const translatedDesc = i18n.t(key, {
		ns: "cols",
		defaultValue: col.desc ?? "",
	});
	const translatedTitle =
		typeof col.title === "string"
			? i18n.t(`title.${key}`, {
					ns: "cols",
					defaultValue: col.title,
				})
			: col.title;

	return {
		...col,
		desc: translatedDesc,
		title: translatedTitle,
	};
};
